// extracted by css-extract-rspack-plugin
export default {"inputWrapper":"GHXPr","inputField":"kwLxj"};